<template>
  <data-table
    :hide-delete="true"
    :hide-edit="true"
    :headers="headers"
    :hide-table-bottom="true"
    :data="payload"
  />
</template>

<script>
import DataTableCurrencyColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCurrencyColumn.vue';
import DataTableCheckBoxColumnVue from '@/app/arch/components/data-table/DataTableColumns/DataTableCheckBoxColumn.vue';
import ProductTypeValueColumn from 'Modules/contacard/produto/templates/produto/components/ProductTypeValueColumn.vue';
import DataTable from '@/app/arch/components/data-table/DataTable.vue';
import TypeComissaoTemplateColumnVue from './TypeComissaoTemplateColumn.vue';
import { itemListaValor } from './ProductTemplateContentValues.vue';
import TypePaidExpanseColumnVue from './TypePaidExpanseColumn.vue';

export default {
  name: 'UserExtendComponent',
  components: { DataTable },
  props: {
    row: {
      type: Object,
      default() {
        return {
          valores: {
            cartaoDebito: [{ ...itemListaValor }],
            cartaoCredito: [{ ...itemListaValor }],
            cartaoCreditoParcelado: [{ ...itemListaValor }],
            pix: [{ ...itemListaValor }],
            prePago: [{ ...itemListaValor }],
            posPago: [{ ...itemListaValor }],
          },
        };
      },
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Forma de pagamento',
        value: 'typePaid',
        component: TypePaidExpanseColumnVue,
      },
      {
        text: 'Tipo comissão',
        value: 'tipoComissaoTemplate',
        component: TypeComissaoTemplateColumnVue,
      },
      {
        text: 'Tipo valor',
        value: 'tipoValorTemplate',
        component: ProductTypeValueColumn,
      },
      {
        text: 'Valor',
        value: 'valor',
        component: DataTableCurrencyColumnVue,
      },
      {
        text: 'Tardio',
        value: 'isValorTardio',
        component: DataTableCheckBoxColumnVue,
      },
    ],
  }),
  computed: {
    getValues() {
      return this.row.valores;
    },
    payload() {
      return Object.keys(this.getValues)
        .map(
          (key) => this.getValues[key].map(
            (item) => ({
              ...item,
              typePaid: key,
            }),
          ),
        ).reduce(
          (arr, item) => {
            item.forEach((el) => {
              arr.push(el);
            });
            return arr;
          },
          [],
        );
    },
  },
};
</script>
